import { createContext } from 'react';

export enum ComposeEmailOrigin {
  Default = 0,
  FolioRequestSection = 1
}

export const ComposeEmailOriginContext = createContext<ComposeEmailOrigin>(ComposeEmailOrigin.Default);
